import React, { useEffect, useState } from "react"
import { Button, Col, Form, Input, Row, Typography } from "antd"

import { Card } from "../../components"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import {
  ChangePasswordApi,
  getUserDetail,
  profileLogoUpload,
  profilechanges
} from "../../app/reducers/authSlice"
import {
  ProfileEmailIcon,
  ProfileNameIcon,
  ProfilePassWordIcon
} from "../../assets/svg"
import TeamMessaage from "../../assets/svg/TeamMessaage"
import Organisation from "../../assets/svg/Organisation"
import { IMAGE_BASE_URL } from "../../api/config"

import classes from "./styles.module.scss"
import UploadLogo from "./components/UploadLogo"

const formItemLayout = {
  labelCol: {
    span: 24
  }
}
export interface UserStateProps {
  firstname?: string
  lastname: string
  username: string
  organization: string
  team: string
  email?: string
  logoImage?: any
  logo: string | null
}

function ProfileInfo() {
  const [form] = Form.useForm()
  const [form2] = Form.useForm()
  const { user, saveuser, fileImg, logodata } = useAppSelector(
    state => state.user
  )
  const dispatch = useAppDispatch()
  const userId = user?.user?.id
  const [userDetails, setUserDetails] = useState<UserStateProps>({
    username: saveuser?.username,
    firstname: saveuser?.firstname || "",
    lastname: saveuser?.lastname || "",
    email: saveuser?.email || "",
    organization: saveuser?.organization || "",
    team: saveuser?.team || "",
    logoImage: `${IMAGE_BASE_URL}${saveuser?.logo?.url}` || null,
    logo: logodata || null
  })
  const [isUserDisable, setIsUserDisable] = useState<boolean>(true)
  const [isPasswordDisabled, setIsPasswordDisabled] = useState<boolean>(true)
  const [responseUser, setUserResponse] = useState(null)
  const [changesUpdated, setChangesUpdated] = useState({})
  const [formData, setFormData] = useState({
    currentPassword: "",
    password: "",
    passwordConfirmation: ""
  })
  const [formErrors, setFormErrors] = useState<Record<string, string>>({})
  // useEffect(() => {
  //   if (apidelay) {
  //     if (fileImg) {
  //       dispatch<any>(profileLogoUpload(fileImg))
  //     }
  //   }
  // }, [apidelay, dispatch, fileImg])
  const handleChangeUser = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setIsUserDisable(false)
  }
  const handleChange = (e: any) => {
    const { name, value } = e.target
    // const trimmedValue = value.trim().replace(/\s+/g, " ")
    setFormData({
      ...formData,
      [name]: value
    })
    setIsPasswordDisabled(false)
  }
  const handleSubmitUser = async () => {
    const currentValues = form2.getFieldsValue()
    const changedValues: Partial<UserStateProps> = {}
    // Iterate through each field and check for empty values
    Object.keys(currentValues).forEach(key => {
      const typedKey = key as keyof UserStateProps
      const value = currentValues[typedKey]?.trim()
      const trimmedValue = value?.replace(/\s\s+/g, " ") // Remove extra space
      if (trimmedValue !== userDetails[typedKey]) {
        changedValues[typedKey] = trimmedValue
      }
    })

    // Update the state with field errors
    setFormErrors(formErrors)

    // Check if there are any errors
    if (Object.keys(formErrors).length === 0) {
      // No errors, proceed with saving changes
      if (fileImg !== null) {
        dispatch<any>(profileLogoUpload(fileImg))
        setChangesUpdated(changedValues)
      }
      if (fileImg === null && Object.keys(changedValues).length > 0) {
        dispatch<any>(
          profilechanges({ changedValues, userId, setUserResponse })
        )
        setIsUserDisable(true)
      }
    }
  }
  useEffect(() => {
    if (logodata) {
      const changedValues = { ...changesUpdated, logo: logodata }
      dispatch(profilechanges({ changedValues, userId, setUserResponse }))
      setIsUserDisable(true)
    }
  }, [logodata, dispatch, userId, userDetails, changesUpdated])
  useEffect(() => {
    if (responseUser) {
      dispatch(getUserDetail(userId))
    }
  }, [dispatch, responseUser, userId])
  const handleSubmit = async () => {
    await dispatch<any>(
      ChangePasswordApi({ formData, form, setIsPasswordDisabled })
    )
  }
  return (
    <div className={`${classes.container} ${classes.profileWrapper}`}>
      <Row>
        <Col span={24}>
          <Typography.Title className={classes.titlePage}>
            Profile
          </Typography.Title>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Card className={classes.cardWrapper}>
            <Row>
              <Col xl={12} lg={18}>
                <Form
                  {...formItemLayout}
                  form={form2}
                  layout="vertical"
                  onFinish={handleSubmitUser}
                  initialValues={userDetails}
                >
                  <Row>
                    <Col span={24}>
                      <Typography.Title className={classes.titleForm}>
                        Info
                      </Typography.Title>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                      <Form.Item
                        label="First name"
                        name="firstname"
                        rules={[
                          {
                            required: true,
                            validator: (_, value) => {
                              if (!value) {
                                return Promise.reject(
                                  new Error("Please enter your Firstname")
                                )
                              }
                              if (value.trim() === "") {
                                return Promise.reject(
                                  new Error("Firstname cannot be empty")
                                )
                              }
                              return Promise.resolve()
                            }
                          }
                        ]}
                        // validateStatus={formErrors.firstname ? "error" : ""}
                        help={formErrors.firstname && formErrors.firstname}
                      >
                        <Input
                          name="firstname"
                          onChange={handleChangeUser}
                          prefix={
                            <span className={classes.inputIcon}>
                              <ProfileNameIcon />
                            </span>
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                      <Form.Item
                        label="Last name"
                        name="lastname"
                        rules={[
                          {
                            required: true,
                            validator: (_, value) => {
                              if (!value) {
                                return Promise.reject(
                                  new Error("Please enter your last name")
                                )
                              }
                              if (value.trim() === "") {
                                return Promise.reject(
                                  new Error("Last name cannot be empty")
                                )
                              }
                              return Promise.resolve()
                            }
                          }
                        ]}
                      >
                        <Input
                          name="lastname"
                          onChange={handleChangeUser}
                          prefix={
                            <span className={classes.inputIcon}>
                              <ProfileNameIcon />
                            </span>
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                      <Form.Item
                        label="Username"
                        name="username"
                        rules={[
                          {
                            required: true,
                            validator: (_, value) => {
                              if (!value) {
                                return Promise.reject(
                                  new Error("Please enter your username")
                                )
                              }
                              if (value.trim() === "") {
                                return Promise.reject(
                                  new Error("Username cannot be empty")
                                )
                              }
                              return Promise.resolve()
                            }
                          }
                        ]}
                      >
                        <Input
                          name="username"
                          onChange={handleChangeUser}
                          prefix={
                            <span className={classes.inputIcon}>
                              <ProfileNameIcon />
                            </span>
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                      <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your email"
                          },
                          { whitespace: true }
                        ]}
                      >
                        <Input
                          name="email"
                          prefix={
                            <span className={classes.inputIcon}>
                              <ProfileEmailIcon />
                            </span>
                          }
                          style={{
                            color: "#fff",
                            pointerEvents: "none"
                          }}
                          readOnly
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                      <Form.Item name="logoImage" valuePropName="file">
                        <UploadLogo
                          setIsUserDisable={setIsUserDisable}
                          updateUserDetails={setUserDetails}
                          updateLogo={userDetails.logoImage}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                      <Form.Item
                        label="Team"
                        name="team"
                        rules={[
                          {
                            required: true,
                            validator: (_, value) => {
                              if (!value) {
                                return Promise.reject(
                                  new Error("Please enter your team name")
                                )
                              }
                              if (value.trim() === "") {
                                return Promise.reject(
                                  new Error("Team name cannot be empty")
                                )
                              }
                              return Promise.resolve()
                            }
                          }
                        ]}
                      >
                        <Input
                          name="team"
                          onChange={handleChangeUser}
                          prefix={
                            <span
                              className={classes.inputIcon}
                              style={{
                                filter:
                                  "brightness(0) saturate(100%) invert(60%) sepia(5%) saturate(595%) hue-rotate(201deg) brightness(82%) contrast(87%)"
                              }}
                            >
                              <TeamMessaage />
                            </span>
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                      <Form.Item
                        label="Organization"
                        name="organization"
                        rules={[
                          {
                            required: true,
                            validator: (_, value) => {
                              if (!value) {
                                return Promise.reject(
                                  new Error(
                                    "Please enter your organization name"
                                  )
                                )
                              }
                              if (value.trim() === "") {
                                return Promise.reject(
                                  new Error("Organization name cannot be empty")
                                )
                              }
                              return Promise.resolve()
                            }
                          }
                        ]}
                      >
                        <Input
                          name="organization"
                          onChange={handleChangeUser}
                          prefix={
                            <span className={classes.inputIcon}>
                              <Organisation />
                            </span>
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Form.Item style={{ display: "flex", justifyContent: "end" }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={isUserDisable}
                    >
                      Save Changes
                    </Button>
                  </Form.Item>
                </Form>
                {saveuser?.provider === "local" && (
                  <Form
                    {...formItemLayout}
                    form={form}
                    layout="vertical"
                    onFinish={handleSubmit}
                  >
                    <Row>
                      <Col span={24}>
                        <Typography.Title className={classes.titleForm}>
                          Change Password
                        </Typography.Title>
                      </Col>
                      <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                          label="Old Password"
                          name="currentPassword"
                          //  initialValue={formData.currentPassword}
                          rules={[
                            {
                              required: true,
                              message: "Please enter your old password!"
                            }
                          ]}
                        >
                          <Input.Password
                            onKeyDown={e => {
                              if (e.key === " ") {
                                e.preventDefault() // Prevent adding spaces
                              }
                            }}
                            name="currentPassword"
                            onChange={handleChange}
                            placeholder="Enter old password"
                            prefix={
                              <span className={classes.inputIcon}>
                                <ProfilePassWordIcon />
                              </span>
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col xl={12} lg={12} md={12} sm={24} xs={24} />
                      <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                          label="New Password"
                          name="password"
                          // initialValue={formData.password}
                          rules={[
                            {
                              required: true,
                              message: "Please enter new password!"
                            },
                            { whitespace: true }
                          ]}
                        >
                          <Input.Password
                            name="password"
                            onKeyDown={e => {
                              if (e.key === " ") {
                                e.preventDefault() // Prevent adding spaces
                              }
                            }}
                            onChange={handleChange}
                            placeholder="Enter new password"
                            prefix={
                              <span className={classes.inputIcon}>
                                <ProfilePassWordIcon />
                              </span>
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                          label="Confirm Password"
                          name="passwordConfirmation"
                          // initialValue={formData.passwordConfirmation}
                          rules={[
                            {
                              required: true,
                              message: "Please confirm new password!"
                            },
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (
                                  !value ||
                                  getFieldValue("password") === value
                                ) {
                                  return Promise.resolve()
                                }
                                return Promise.reject(
                                  new Error(
                                    "Your confirm password are not match with new password!"
                                  )
                                )
                              }
                            })
                          ]}
                        >
                          <Input.Password
                            onKeyDown={e => {
                              if (e.key === " ") {
                                e.preventDefault() // Prevent adding spaces
                              }
                            }}
                            name="passwordConfirmation"
                            onChange={handleChange}
                            placeholder="Enter confirm new password"
                            prefix={
                              <span className={classes.inputIcon}>
                                <ProfilePassWordIcon />
                              </span>
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Form.Item
                      style={{ display: "flex", justifyContent: "end" }}
                    >
                      <Button
                        type="primary"
                        htmlType="submit"
                        disabled={isPasswordDisabled}
                      >
                        Save Changes
                      </Button>
                    </Form.Item>
                  </Form>
                )}
                <Col xl={12} lg={12} md={12} sm={24} xs={24} />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default ProfileInfo
